<template>
  <div>
    <transition name="fade">
      <div v-if="loading.district" class="statistics__loader-wrapper">
        <Spinner />
      </div>
    </transition>
    <div class="statistics__upper-graph-header">
      <h2 :title="graphTitle">{{ graphTitle }}</h2>
      <label v-if="!districtIsSelected" class="statistics__upper-graph-toggle">
        Toon zetels
        <input v-model="provincialVoteView" type="checkbox" >
      </label>
      <label class="statistics__upper-graph-toggle">
        Sorteer op aantal {{ graphUnits.toLowerCase() }}
        <input v-model="sortOnValues" type="checkbox" >
      </label>
    </div>
    <div v-if="vertBarGraphData && vertBarGraphData.datasets.find(d => d.values.length)" class="statistics__graphs-container">
      <div class="statistics__expand" @click="initDistrictModal"/>
      <BarChart :args="vertBarGraphData" class="statistics__upper-graph" @onDataClick="openModal" />
    </div>
    <h3 v-else class="statistics__upper-graph-no-results">Er zijn nog geen zetels bekend</h3>
  </div> 
</template>

<script>
import { mapState, mapGetters } from "vuex";
import modal from "../../services/tableModal.js";
import BarChart from "../charts/BarChart.vue";
import Spinner from "../Spinner.vue";
import { confirm } from "../../services/dialog.js";

export default {
  components: { BarChart, Spinner },
  data() {
    return {
      provincialVoteView: false,
      sortOnValues: false
    };
  },
  computed: {
    ...mapState({
      demographic: state => state.feed.provincialData.demographic,
      selectedDistrict: state => state.feed.selectedDistrict,
      seats: state => state.feed.provincialData.seats,
      loading: state => state.feed.loading,
      lastUpdated: state => state.feed.lastUpdated
    }),
    ...mapGetters("feed", [
      "provincialPartySeats",
      "votingBehavior",
      "districtPartyResults",
      "getCompletedDistricts",
      "getProvincialTotals",
      "getProvinceSetting",
      "provincialPartyVotes"
    ]),
    graphTitle() {
      return `${this.showPrefix ? this.prefixSeats._text || "" : ""} ${
        this.showPrefix ? this.graphUnits || "" : this.graphUnits
      } ${!this.districtIsSelected ? this.postfix._text || "" : ""}`;
    },
    vertBarGraphData() {
      // JSON parse with self invoking function to determine which data without observers we are going to use
      const data = JSON.parse(
        JSON.stringify(
          (() => {
            if (this.districtIsSelected && this.districtPartyResults) {
              return this.districtPartyResults;
            }
            return this.provincialVoteView
              ? this.provincialPartySeats
              : this.provincialPartyVotes;
          })()
        )
      );
      // sort on the first dataset entry
      if (this.sortOnValues) {
        const datasetKey = !data.datasets[1].values.reduce((a, b) => a + b)
          ? 0
          : 1; //sort on the relevant dataset
        const sortSet = data.datasets[datasetKey];

        // if no sets have any values we return the normal data
        if (!sortSet) {
          return data;
        }
        let sortableArray = [];
        for (const key in sortSet.values) {
          sortableArray.push({
            data: data.datasets.map(s => s.values[key] || 0),
            label: data.labels[key]
          });
        }
        sortableArray = sortableArray.sort(
          (a, b) => b.data[datasetKey] - a.data[datasetKey]
        );
        data.labels = sortableArray.map(set => set.label);
        data.datasets = data.datasets.map((s, key) => ({
          ...s,
          values: sortableArray.map(set => set.data[key])
        }));
      }
      return data;
    },
    districtIsSelected() {
      return Object.keys(this.selectedDistrict).length;
    },
    activeDataObj() {
      if (this.districtIsSelected) {
        return this.selectedDistrict;
      }
      if (!this.districtIsSelected && this.provincialVoteView) {
        return this.seats.Uitslag;
      }
      return this.demographic;
    },
    graphUnits() {
      // Might need more complexity later on
      return this.districtIsSelected || !this.provincialVoteView
        ? "Stemmen"
        : "Zetels";
    },
    prefixSeats() {
      return this.seats.Uitslag.Title.Prefix;
    },
    showPrefix() {
      return !this.districtIsSelected && this.provincialVoteView;
    },
    postfix() {
      return this.demographic.Title.Postfix;
    }
  },
  watch: {
    "prefixSeats._text": {
      handler(val) {
        if (val) {
          this.checkForNewSeatState(val);
        }
      },
      immediate: true
    }
  },
  methods: {
    initDistrictModal() {
      modal(this.activeDataObj);
    },
    openModal(...params) {
      const index = params[0]._index;
      const meta = params.pop();
      const shortNameIndex = this.vertBarGraphData.labels[index];
      if (meta && meta.fullNames) {
        modal(this.activeDataObj, {
          party: meta.fullNames.find(p => p[shortNameIndex])[shortNameIndex],
          provinceMeta: this.getProvinceSetting
        });
      }
    },
    checkForNewSeatState(state) {
      if (!sessionStorage.getItem(state)) {
        sessionStorage.setItem(state, true);
        confirm(
          `${state} zetels is nieuw binnen`,
          "Er zijn nieuwe zetel resultaten binnen! Klik op 'bekijk nu' om deze te openen.",
          "Bekijk nu",
          "",
          false
        ).then(() => {
          modal(this.seats.Uitslag);
        });
      }
    }
  }
};
</script>

<style>
/* styling is inherited from parent */
</style>
